/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FufiContributionType = {
    Employer: 'Employer',
    Employee: 'Employee',
    Unknown: 'Unknown'
} as const;
export type FufiContributionType = typeof FufiContributionType[keyof typeof FufiContributionType];


export function instanceOfFufiContributionType(value: any): boolean {
    for (const key in FufiContributionType) {
        if (Object.prototype.hasOwnProperty.call(FufiContributionType, key)) {
            if (FufiContributionType[key as keyof typeof FufiContributionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FufiContributionTypeFromJSON(json: any): FufiContributionType {
    return FufiContributionTypeFromJSONTyped(json, false);
}

export function FufiContributionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiContributionType {
    return json as FufiContributionType;
}

export function FufiContributionTypeToJSON(value?: FufiContributionType | null): any {
    return value as any;
}

export function FufiContributionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FufiContributionType {
    return value as FufiContributionType;
}

